// Shared customer-facing cancellation-schedule copy, single-sourced so the customer
// quote (CustomerQuoteView) and the golfer pay-share page (PayShare) render the
// SAME bullets from a stored cancellation object (Expedia disclosure snapshot:
// { refundable, freeCancelBefore, nonRefundableAfter, penaltyNights }).
//
// Cancel-schedule dates carry the property's UTC offset — format the wall-clock
// components directly so they read in the PROPERTY's local time, not the viewer's.
export function fmtCancelLocalDT(iso, fr) {
  const m = String(iso || '').match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/)
  if (!m) return ''
  const dt = new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5])
  const date = dt.toLocaleDateString(fr ? 'fr-CA' : 'en-CA', { day: '2-digit', month: 'short', year: 'numeric' })
  const time = dt.toLocaleTimeString(fr ? 'fr-CA' : 'en-US', { hour: 'numeric', minute: '2-digit', hour12: !fr })
  return `${date}, ${time}`
}

// Returns an array of plain-text bullets for the stored cancellation object.
// Empty when there's no schedule to show. A stored `refundable: false` is the
// single non-refundable line; a null/absent `refundable` yields no bullets.
export function cancellationBullets(cx, fr) {
  const out = []
  if (!cx) return out
  const dt = (iso) => fmtCancelLocalDT(iso, fr)
  if (cx.refundable && cx.freeCancelBefore) {
    out.push(fr ? `Annulation gratuite jusqu'au ${dt(cx.freeCancelBefore)}.` : `Free cancellation until ${dt(cx.freeCancelBefore)}.`)
    if (cx.penaltyNights && cx.nonRefundableAfter) {
      const n = cx.penaltyNights
      out.push(fr
        ? `Après le ${dt(cx.freeCancelBefore)}, une annulation entraîne une pénalité de ${n} nuit${n > 1 ? 's' : ''} plus taxes et frais jusqu'au ${dt(cx.nonRefundableAfter)}.`
        : `After ${dt(cx.freeCancelBefore)}, cancellations will result in a ${n} night penalty plus taxes and fees until ${dt(cx.nonRefundableAfter)}.`)
    }
    if (cx.nonRefundableAfter) {
      out.push(fr
        ? `Après le ${dt(cx.nonRefundableAfter)}, la réservation devient entièrement non remboursable.`
        : `The end time for the cancellation window is ${dt(cx.nonRefundableAfter)}, at which time the booking becomes fully non-refundable.`)
    }
    out.push(fr
      ? `Si vous ne vous présentez pas, ou si vous annulez ou modifiez cette réservation après l'arrivée, des frais de pénalité peuvent s'appliquer à la discrétion de l'établissement (jusqu'à 100 % de la valeur de la réservation).`
      : `If you fail to check in, or if you cancel or change this reservation after check-in, you may incur penalty charges at the property's discretion (up to 100% of the booking value).`)
  } else if (cx.refundable === false) {
    out.push(fr ? 'Ce tarif est non remboursable.' : 'This rate is non-refundable.')
  }
  return out
}
